// Copyright 2026, Imprivata, Inc.  All rights reserved.

export type GracePeriodContextType = 'endpoint-login' | 'clinical-app-login';

export type GracePeriodSecs = number;

export const GRACE_PERIOD_PRESETS = [16200, 30600, 46800, 86400] as const;

// Sentinel used in form state to represent the "Other" (custom) option.
// Resolved to the user-typed value before any API call.
export const OTHER_SENTINEL = -1 as const;
